import React, { useState } from "react";
import "../../popups.css";

const AddFamilyMemberPopup = ({ onClose, onNext }) => {
  const [photos, setPhotos] = useState([
    "../assets/images/d-user.jpg",
    "../assets/images/d-user.jpg",
  ]);

  const handleImageUpload = (e) => {
    const file = e.target.files[0];
    if (file) {
      const newPhoto = URL.createObjectURL(file);
      setPhotos([...photos, newPhoto]);
    }
  };

  return (
    <div className="addfamily-overlay">
      <div className="addfamily-card">
        {/* ===== HEADER ===== */}
        <div className="addfamily-header">
          <div className="header-left">
            <div className="">
              <img src="/assets/images/add-member.svg" alt="user" />
            </div>
            <div>
              <h2 className="add-mem">Add Member</h2>
              <p>
                Add details for a new family member by providing personal and
                relationship info. Learn from below form.
              </p>
            </div>
          </div>
          <button className="close-btn" onClick={onClose}>
            &times;
          </button>
        </div>

        {/* ===== RELATION BAR ===== */}
        <div className="relation-bar">
          <div className="relation-item">
            <label>Bio/Spouse/Child As Parents</label>
            <p>Vidia Verma</p>
          </div>
          <div className="relation-item">
            <label>Type of Line</label>
            <p>Joseph McDonnell</p>
          </div>
          <div className="relation-item">
            <label>Family Line/Color</label>
            <p>Red</p>
          </div>
          <div className="relation-item">
            <label>Relation to Top of line</label>
            <p>Daughter</p>
          </div>
        </div>

        {/* ===== BODY ===== */}
        <div className="addfamily-body">
          {/* === BASIC INFO === */}
          <div className="addfamily-section">
            <div className="addfamily-section-header">
              <h3>Basic Info</h3>
            </div>

            {/* ===== Image Row ===== */}
            <div className="image-row addmember-image-row">
              {photos.map((src, index) => (
                <div key={index} className="member-photo">
                  <img src={src} alt={`Member ${index + 1}`} />
                </div>
              ))}
              <div className="add-photo">
                <label>
                  <span>+</span>
                  <input
                    type="file"
                    accept="image/*"
                    style={{ display: "none" }}
                    onChange={handleImageUpload}
                  />
                </label>
              </div>
            </div>

            <div className="addfamily-form-grid">
              <div className="addfamily-form-group">
                <label>First Name</label>
                <input type="text" placeholder="Enter first name" />
              </div>
              <div className="addfamily-form-group">
                <label>Middle Name</label>
                <input type="text" placeholder="Enter middle name" />
              </div>
              <div className="addfamily-form-group">
                <label>Last Name</label>
                <input type="text" placeholder="Enter last name" />
              </div>
              <div className="addfamily-form-group">
                <label>Suffix</label>
                <input type="text" placeholder="Enter suffix" />
              </div>
            </div>
          </div>

          {/* === PERSONAL INFO === */}
          <div className="addfamily-section">
            <div className="addfamily-section-header">
              <h3>Personal Info</h3>
            </div>
            <div className="addfamily-form-grid">
              <div className="addfamily-form-group">
                <label>Gender</label>
                <select>
                  <option value="">Select</option>
                  <option>Male</option>
                  <option>Female</option>
                  <option>Other</option>
                </select>
              </div>
              <div className="addfamily-form-group">
                <label>Date of Birth</label>
                <input type="date" />
              </div>
              <div className="addfamily-form-group">
                <label>Birth Place</label>
                <input type="text" placeholder="Enter birth place" />
              </div>
              <div className="addfamily-form-group">
                <label>Current Residence</label>
                <input type="text" placeholder="Enter current residence" />
              </div>
              <div className="addfamily-form-group">
                <label>Status</label>
                <select>
                  <option>Present</option>
                  <option>Widowed</option>
                  <option>Deceased</option>
                </select>
              </div>
              <div className="addfamily-form-group">
                <label>Wedding Anniversary</label>
                <input type="date" />
              </div>
              <div className="addfamily-form-group full-width">
                <label>Native Location</label>
                <input type="text" placeholder="Enter native place" />
              </div>
              <div className="addfamily-form-group full-width">
                <label>Notes</label>
                <textarea rows="3" placeholder="Additional notes"></textarea>
              </div>
            </div>
          </div>

          {/* === CONTACT INFO === */}
          <div className="addfamily-section">
            <div className="addfamily-section-header">
              <h3>Contact Info</h3>
            </div>
            <div className="addfamily-form-grid">
              <div className="addfamily-form-group">
                <label>Phone</label>
                <input type="text" placeholder="Enter phone number" />
              </div>
              <div className="addfamily-form-group">
                <label>Email</label>
                <input type="email" placeholder="Enter email" />
              </div>
            </div>
          </div>
        </div>

        {/* ===== FOOTER ===== */}
        <div className="addfamily-actions">
          <button className="btn-outline" onClick={onClose}>
            Cancel
          </button>
          <button className="btn-danger" onClick={onNext}>
            Add Member
          </button>
        </div>
      </div>
    </div>
  );
};

export default AddFamilyMemberPopup;
